/**
 * defaultTemplates.js — Canonical list of the 6 class templates.
 *
 * These are the hardcoded defaults that are always available even if no
 * Firestore override exists. useTemplates() merges these with any Firestore
 * overrides so every consumer (TemplateEditor, ClassCardsManager, etc.)
 * always sees all 6 templates.
 *
 * Only Square-sourced fields live here. Operational details (duration,
 * spots, location, description) belong on Class Cards, not templates.
 */

export const DEFAULT_TEMPLATES = [
  {
    id: 'bowl-workshop',
    name: 'Bowl Workshop',
    color: '#E8A020',
    price: 85,
    visibility: 'Public',
    squareCatalogItemId: 'MJ27OQ2HFKEW7CKYWRL7KXC7',
    squareVariationId: 'NVRR7WWSU4ZPU3WDBIK3NG6H',
    squareCategoryId: '7YZBDI54VSHTLDXCWOK3QHJJ',
    squareCategoryName: 'Hand Building',
  },
  {
    id: 'planter-workshop',
    name: 'Planter Workshop',
    color: '#4A6FA5',
    price: 85,
    visibility: 'Public',
    squareCatalogItemId: 'GXMNSPKL5YGOE2VIIXNG4MF7',
    squareVariationId: 'GDZAZBFNXJDWAWAC6HYANXJS',
    squareCategoryId: '7YZBDI54VSHTLDXCWOK3QHJJ',
    squareCategoryName: 'Hand Building',
  },
  {
    id: 'pottery-party',
    name: 'Pottery Party',
    color: '#7A3A5A',
    price: 85,
    visibility: 'Private',
    squareCatalogItemId: 'NOMWM4Y4Q7LYJQ2OWXTJPWSM',
    squareVariationId: 'WQKQ4FBU7CEDUXZNDOT4KIQY',
    squareCategoryId: '7YZBDI54VSHTLDXCWOK3QHJJ',
    squareCategoryName: 'Hand Building',
  },
  {
    id: 'mug-workshop',
    name: 'Mug Workshop',
    color: '#4A7A5C',
    price: 85,
    visibility: 'Public',
    squareCatalogItemId: 'MMM7PFGX6S22ZSN2KJ7FSMKY',
    squareVariationId: 'EFR7YV2ZNNWEMDLCQ6SD2OIK',
    squareCategoryId: '7YZBDI54VSHTLDXCWOK3QHJJ',
    squareCategoryName: 'Hand Building',
  },
  {
    id: 'vase-workshop',
    name: 'Vase Workshop',
    color: '#B55A3A',
    price: 85,
    visibility: 'Public',
    squareCatalogItemId: '5SU2WQYJ7A7CEICZSOSRDS5P',
    squareVariationId: '4MEWI3GJJVA5JWLK6EBSRV22',
    squareCategoryId: '7YZBDI54VSHTLDXCWOK3QHJJ',
    squareCategoryName: 'Hand Building',
  },
  {
    id: 'wheel-throwing',
    name: 'Wheel Throwing',
    color: '#3A7A7A',
    price: 120,
    visibility: 'Private',
    squareCatalogItemId: 'MBS53MTQMUNZT2QV4SCQ6GEV',
    squareVariationId: 'ZZRGV5P7NLPZ6SNJRPOAW34S',
    squareCategoryId: 'SX7DNDJQENUCOZDPMGHGJANB',
    squareCategoryName: 'Wheel Throwing',
  },
];

// Maps templateId → ClassIcon component id
export const TEMPLATE_TO_CLASS_ICON = {
  'bowl-workshop': 1,
  'wheel-throwing': 2,
  'planter-workshop': 4,
  'vase-workshop': 5,
  'pottery-party': 6,
  'mug-workshop': 7,
};

/**
 * Merge DEFAULT_TEMPLATES with Firestore overrides.
 * Empty strings in Firestore (from old saves) fall back to hardcoded defaults
 * so Square IDs are never accidentally blanked out.
 */
export function mergeWithDefaults(firestoreTemplates) {
  return DEFAULT_TEMPLATES.map((def) => {
    const override = firestoreTemplates.find((t) => t.id === def.id);
    if (!override) return def;
    const merged = { ...def };
    Object.keys(override).forEach((key) => {
      if (
        override[key] !== '' &&
        override[key] !== null &&
        override[key] !== undefined
      ) {
        merged[key] = override[key];
      }
    });
    return merged;
  });
}
